// extracted by mini-css-extract-plugin
module.exports = {"cls1":"StyledComponents-Container_cls1__3xaju","cls2":"StyledComponents-Container_cls2__2J2nw StyledComponents-Container_cls1__3xaju"};